import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import useLocale from '../hooks/useLocale';
import { useViewport } from '../hooks/useViewport';
import { LinkWithEnglishSuperset } from './Link';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { BulbIcon, CodeIcon } from 'foundations-assets';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
/**
 * External non-router-aware `UILink` when not on developers.hubspot.com, otherwise
 * strip the domain to make `to` absolute.
 *
 * TODO: Add tests and other envs if we go this way
 */ // the passed in hrefs come from SHADE and are either external or referencing the qa or prod domain
const URL_REGEX = /(https:\/\/)?developers\.(wt)?hubspot\.(com|de|es|fr|jp)(\/(docs))?/g;
const getRelativeHref = href => href.replace(URL_REGEX, '');
const FormattedLink = ({
  external,
  href,
  children,
  showEnTag,
  getEnglishBaseUrl
}) => {
  if (external) {
    return /*#__PURE__*/_jsx(Link, {
      external: true,
      href: href,
      children: children
    });
  }
  const relativeHref = getRelativeHref(href);
  if (showEnTag) {
    return /*#__PURE__*/_jsx(LinkWithEnglishSuperset, {
      href: getEnglishBaseUrl(relativeHref),
      children: children
    });
  }
  return /*#__PURE__*/_jsx(UIRouterLink, {
    to: relativeHref,
    children: children
  });
};

/**
 * The 'Related guide' section shown in an API's intro and use case card.
 */
const RelatedDocs = ({
  href,
  title,
  relatedDocType,
  localization
}) => {
  const viewportContext = useViewport();
  const locale = useLocale();
  const external = href.match(URL_REGEX) === null && href.charAt(0) !== '/';
  const relativeHref = getRelativeHref(href);
  const localizationProps = localization && !external && !localization.isUrlLocalized(relativeHref, locale) ? {
    showEnTag: true,
    getEnglishBaseUrl: localization.getEnglishBaseUrl
  } : {
    showEnTag: false
  };
  const docTypeMap = {
    guide: {
      icon: /*#__PURE__*/_jsx(BulbIcon, {
        color: "icon-core-subtle",
        size: "600"
      }),
      link: /*#__PURE__*/_jsxs(Flex, {
        flexDirection: viewportContext.isMobile ? 'column' : 'row',
        gap: viewportContext.isMobile ? '50' : '300',
        alignItems: "baseline",
        children: [/*#__PURE__*/_jsx(Text, {
          typography: "heading-100",
          as: "h4",
          marginInlineStart: viewportContext.isMobile ? '0' : '100',
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "developer-docs-shared-components.relatedDocs.relatedGuideTitle"
          })
        }), /*#__PURE__*/_jsx(FormattedLink, Object.assign({
          external: external,
          href: href
        }, localizationProps, {
          children: title
        }))]
      })
    },
    api: {
      icon: /*#__PURE__*/_jsx(CodeIcon, {
        color: "icon-core-subtle",
        size: "600"
      }),
      link: /*#__PURE__*/_jsx(FormattedLink, Object.assign({
        external: external,
        href: href
      }, localizationProps, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "developer-docs-shared-components.relatedDocs.relatedApiTitle",
          options: {
            apiLabel: title
          }
        })
      }))
    }
  };
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "row",
    gap: "200",
    alignItems: "center",
    marginBlockStart: relatedDocType === 'guide' && viewportContext.isDesktop ? '1200' : '800',
    marginBlockEnd: "600",
    children: [docTypeMap[relatedDocType].icon, docTypeMap[relatedDocType].link]
  });
};
export default RelatedDocs;